var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightningCircled(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.439 22c6.35 0 11.497-4.925 11.497-11S18.79 0 12.44 0 .94 4.925.94 11 6.09 22 12.44 22z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.439 22c6.35 0 11.497-4.925 11.497-11S18.79 0 12.44 0 .94 4.925.94 11 6.09 22 12.44 22z",
    fill: "#C8ACA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.497 10.404h-2.505l1.475-5.037c.095-.304-.318-.501-.524-.258l-5.932 6.767a.285.285 0 00.222.47h2.506l-1.475 5.038c-.095.303.317.5.524.258l5.947-6.768c.159-.182.016-.47-.238-.47z",
    fill: "#000"
  })));
}
export default SvgLightningCircled;